module.exports = __webpack_public_path__ + "static/media/longs-drugs.0af26fa6.png";